import { render } from "./DeliveryMethode.vue?vue&type=template&id=4dc928f1"
import script from "./DeliveryMethode.vue?vue&type=script&lang=js"
export * from "./DeliveryMethode.vue?vue&type=script&lang=js"

import "./DeliveryMethode.vue?vue&type=style&index=0&id=4dc928f1&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__